<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Button type="primary" icon="md-add" class="search_tn" data-level="common" @click="addListModal = true">生成标签</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" v-if="row.status == 3">铺码中</a>
          <a class="jump_color" v-if="row.status == 9">铺码失败，请联系客服</a>
          <a class="jump_color" v-if="row.status >= 4 && row.status != 9" :href="downloadPdf + row.dotFile" :download="downloadPdf + row.dotFile" target="_blank">下载</a>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getLabelList"></paging>
    <Modal class="top_search_modal" v-model="addListModal" title="生成标签">
      <div class="top_search_wrapper">
        <Input class="search-ipt search_item" type="number" v-model="tagsNum" placeholder="请输入标签张数" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="addListModal = false">取消</Button>
        <Button class="add_record_btn" type="info" @click="confirmAddLabel">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import paging from '../templates/Paging.vue';
  import {dealDate} from '../common/common';
  import global from '../common/Global';
  import {_addLabel,_getLabelList} from '../api/api';
  let timer = null;
  export default {
    components: {paging},
    data() {
      return {
        downloadPdf:global.downLoadPdf,// 下载pdf
        pageSize:10, // 每页条数
        currentNum: 0, // 当前页码
        totalNum: 0, // 数据总条数
        addListModal:false, // 新增弹框
        deleteStatus:false,//删除弹框
        selectedNum:0,// 已选中的数量
        tagsNum:null,// 标签张数
        tableHeader: [
          {
            title: '编号',
            key:'id',
          },
          {
            title: '生成时间',
            key:'createTime',
          },
          {
            title: '张数',
            key:'pageCount',
          },
          {
            title: '操作',
            slot: 'action',
            align:"center",
          },
        ],
        tableData:[],
      }
    },
    methods: {
//      确定添加标签
      confirmAddLabel(){
        const self = this;
        let dataInfo = {
          count: self.tagsNum
        };
        _addLabel(dataInfo).then(res => {
          if(res.code === 0) {
            self.addListModal = false;
            self.getLabelList();
            timer = setInterval(this.getLabelList, 5000)
          }
        })
      },
//      获取学生列表
      getLabelList(msg){
        const self = this;
        let params = {
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize,
          sort:"createTime,desc"
        };
        _getLabelList({params:params}).then(res => {
          if(res.code === 0) {
            if(res.data.content.length > 0) {
              res.data.content.forEach(item => {
                item.createTime = dealDate(item.createTime);
              });
              let status = res.data.content.every(item => {
                return (item.status >= 4 || item.status == 2 || item.status == 0);
              });
              status && clearInterval(timer);
            }else{
              clearInterval(timer);
            }
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
          }else{
            clearInterval(timer);
          }
        })
          .catch(() => {
            clearInterval(timer);
          })
      },
    },
    created() {
      timer = setInterval(this.getLabelList, 5000);
      this.getLabelList();
    },
    mounted() {

    },
    beforeRouteLeave(to,from,next){
      clearInterval(timer);
      next();
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LabelManagement.vue